import React from "react";
import { useAuth } from "../Auth/AuthContext";
import Login from "../Login/Login";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Login></Login>;
};

export default PrivateRoute;
